var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9735 16.3011L0.663452 8.83587C0.387309 8.35758 0.551185 7.74599 1.02948 7.46984L12.6936 0.735558C12.8592 0.639968 13.0487 0.593841 13.2396 0.602644L20.2225 0.924506C20.9025 0.955846 21.3531 1.64256 21.1112 2.27879L18.3837 9.45372C18.3019 9.66891 18.1483 9.84929 17.949 9.9644L6.33952 16.6671C5.86123 16.9433 5.24964 16.7794 4.9735 16.3011ZM16.8544 5.66246C16.8544 6.56482 16.1229 7.29632 15.2206 7.29632C14.3182 7.29632 13.5867 6.56482 13.5867 5.66246C13.5867 4.76011 14.3182 4.0286 15.2206 4.0286C16.1229 4.0286 16.8544 4.76011 16.8544 5.66246ZM6.26786 17.8996L5.87989 17.2276C6.1926 17.4857 6.64492 17.5369 7.0167 17.3223L18.6261 10.6196C18.8255 10.5044 18.9791 10.3241 19.0609 10.1089L21.7884 2.93394C21.8309 2.82209 21.852 2.70867 21.8543 2.59753C22.3348 2.79623 22.6046 3.35385 22.4056 3.8773L19.6781 11.0522C19.5962 11.2674 19.4427 11.4478 19.2433 11.5629L7.63388 18.2656C7.15559 18.5418 6.544 18.3779 6.26786 17.8996Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.455a5f207c9e0e05168aa7f7399ec52f.svg";
export { ForwardRef as ReactComponent };